var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3015_7399",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5H0V24.5H24V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3015_7399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15957 12.12C9.12957 12.12 9.10957 12.12 9.07957 12.12C9.02957 12.11 8.95957 12.11 8.89957 12.12C5.99957 12.03 3.80957 9.75 3.80957 6.94C3.80957 4.08 6.13957 1.75 8.99957 1.75C11.8596 1.75 14.1896 4.08 14.1896 6.94C14.1796 9.75 11.9796 12.03 9.18957 12.12C9.17957 12.12 9.16957 12.12 9.15957 12.12ZM8.99957 3.25C6.96957 3.25 5.30957 4.91 5.30957 6.94C5.30957 8.94 6.86957 10.55 8.85957 10.62C8.91957 10.61 9.04957 10.61 9.17957 10.62C11.1396 10.53 12.6796 8.92 12.6896 6.94C12.6896 4.91 11.0296 3.25 8.99957 3.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5396 12.25C16.5096 12.25 16.4796 12.25 16.4496 12.24C16.0396 12.28 15.6196 11.99 15.5796 11.58C15.5396 11.17 15.7896 10.8 16.1996 10.75C16.3196 10.74 16.4496 10.74 16.5596 10.74C18.0196 10.66 19.1596 9.46 19.1596 7.99C19.1596 6.47 17.9296 5.24 16.4096 5.24C15.9996 5.25 15.6596 4.91 15.6596 4.5C15.6596 4.09 15.9996 3.75 16.4096 3.75C18.7496 3.75 20.6596 5.66 20.6596 8C20.6596 10.3 18.8596 12.16 16.5696 12.25C16.5596 12.25 16.5496 12.25 16.5396 12.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16961 23.05C7.20961 23.05 5.23961 22.55 3.74961 21.55C2.35961 20.63 1.59961 19.37 1.59961 18C1.59961 16.63 2.35961 15.36 3.74961 14.43C6.74961 12.44 11.6096 12.44 14.5896 14.43C15.9696 15.35 16.7396 16.61 16.7396 17.98C16.7396 19.35 15.9796 20.62 14.5896 21.55C13.0896 22.55 11.1296 23.05 9.16961 23.05ZM4.57961 15.69C3.61961 16.33 3.09961 17.15 3.09961 18.01C3.09961 18.86 3.62961 19.68 4.57961 20.31C7.06961 21.98 11.2696 21.98 13.7596 20.31C14.7196 19.67 15.2396 18.85 15.2396 17.99C15.2396 17.14 14.7096 16.32 13.7596 15.69C11.2696 14.03 7.06961 14.03 4.57961 15.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3397 21.25C17.9897 21.25 17.6797 21.01 17.6097 20.65C17.5297 20.24 17.7897 19.85 18.1897 19.76C18.8197 19.63 19.3997 19.38 19.8497 19.03C20.4197 18.6 20.7297 18.06 20.7297 17.49C20.7297 16.92 20.4197 16.38 19.8597 15.96C19.4197 15.62 18.8697 15.38 18.2197 15.23C17.8197 15.14 17.5597 14.74 17.6497 14.33C17.7397 13.93 18.1397 13.67 18.5497 13.76C19.4097 13.95 20.1597 14.29 20.7697 14.76C21.6997 15.46 22.2297 16.45 22.2297 17.49C22.2297 18.53 21.6897 19.52 20.7597 20.23C20.1397 20.71 19.3597 21.06 18.4997 21.23C18.4397 21.25 18.3897 21.25 18.3397 21.25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeam);
export default __webpack_public_path__ + "static/media/icon-team.fa5d6bb3a11f8fe6fafc1363dcece625.svg";
export { ForwardRef as ReactComponent };